import { render, staticRenderFns } from "./Attr.vue?vue&type=template&id=8999a1d8"
import script from "./Attr.vue?vue&type=script&lang=js"
export * from "./Attr.vue?vue&type=script&lang=js"
import style0 from "./Attr.vue?vue&type=style&index=0&id=8999a1d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports